/**
 * External dependencies
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classnames from "classnames";

/**
 * Internal dependencies
 */
import {
  isSectionLoading,
  getSectionName,
  getCurrentPath,
} from "state/ui/selectors";
import DocumentHead from "data/document-head";
import GlobalNotices from "blocks/global-notices";
import { getPreference } from "state/preferences/selectors";
import AutoSaveLayout from "data/auto-save-layout";
import { ConfigProvider } from "antd";
import { ActivePartnerProvider } from "../data/active-partner-provider";

class Layout extends Component {
  static propTypes = {
    primary: PropTypes.element,
    secondary: PropTypes.element,
  };

  componentDidMount() {
    if (typeof document !== "undefined") {
      if (this.props.colorSchemePreference) {
        document
          .querySelector("body")
          .classList.add(`is-${this.props.colorSchemePreference}`);
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.colorSchemePreference === this.props.colorSchemePreference) {
      return;
    }
    if (typeof document !== "undefined") {
      const classList = document.querySelector("body").classList;
      classList.remove(`is-${prevProps.colorSchemePreference}`);
      classList.add(`is-${this.props.colorSchemePreference}`);
    }
  }

  render() {
    const sectionClass = classnames(
      "layout",
      { "show-grid": this.props.showGrid },
      `is-section-${this.props.sectionName}`
    );

    const loadingClass = classnames({
      layout__loader: true,
      "is-active": this.props.isLoading,
    });
    return (
      <ActivePartnerProvider>
        <ConfigProvider>
          <div className={sectionClass}>
            <DocumentHead />
            <GlobalNotices />
            <AutoSaveLayout />
            <div className={loadingClass}>
              {this.props.isLoading && <div>loading!</div>}
            </div>
            {this.props.topbar}
            <div id="content" className="layout__content">
              <div id="primary" className="layout__primary">
                {this.props.primary}
              </div>
            </div>
          </div>
        </ConfigProvider>
      </ActivePartnerProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: isSectionLoading(state),
    sectionName: getSectionName(state),
    path: getCurrentPath(state),
    colorSchemePreference: getPreference(state, "colorScheme"),
    showGrid: getPreference(state, "gridVisible"),
  };
};

export default connect(mapStateToProps, {})(Layout);
